import React, { useState } from 'react';
import '../../styles/common.css';
import '../../styles/modal.css';
import '../../styles/mfa-modal.css';
import axiosInstance, { resetSessionExpiredFlag } from '../../api/axiosInstance';
import { toast } from 'react-toast';
import { setDateTimePrefs } from '../../utils/dateTimeFormat';
import { setTourCompleted } from '../../utils/productTourStatus';

const API_BASE_URL = process.env.REACT_APP_BASE_URL;

const MFAVerificationModal = ({ onClose, onVerified }) => {
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleVerify = async () => {
    setIsLoading(true);
    setError('');

    try {
      const storedLoginData = JSON.parse(localStorage.getItem('tempLoginData') || '{}');
      const response = await axiosInstance.post(`/users/verify_mfa`, {
        user_id: storedLoginData.userId,
        mfa_code: code
      });

      if (response.status_code === 200) {
        const userData = {
          username: storedLoginData.username,
          userId: storedLoginData.userId,
          accessToken: response.access_token,
          user_type: storedLoginData.user_type,
          is_wizard_completed: response.is_wizard_completed ?? storedLoginData.is_wizard_completed
        };
        localStorage.setItem('user', JSON.stringify(userData));
        localStorage.setItem('isAuthenticated', 'true');
        setDateTimePrefs(response.account_settings || storedLoginData.account_settings);
        setTourCompleted(response.tour_completed ?? storedLoginData.tour_completed);
        resetSessionExpiredFlag();
        localStorage.removeItem('tempLoginData');
        
         onVerified();
        toast.success('Login successful');
      } else {
        setError('Verification failed. Please try again.');
      }
    } catch (error) {
      console.error('MFA verification error:', error);
      setError(error.response?.data?.message || 'Failed to verify MFA code. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div data-rt-modal-overlay className="modal-overlay" onClick={(e) => e.target.className === 'modal-overlay' && onClose()}>
      <div className="modal-content mfa-modal">
        <div className="modal-header">
          <h2>MFA Verification</h2>
          <button className="close-button" onClick={onClose} disabled={isLoading}>×</button>
        </div>
        <div className="modal-body">
          <div className="mfa-description">
            Please enter the verification code from your authenticator app to continue.
          </div>
          <div className="form-group">
            <label htmlFor="mfa-code" className="form-label">Verification Code</label>
            <input
              type="text"
              id="mfa-code"
              className="form-input"
              value={code}
              onChange={(e) => setCode(e.target.value.replace(/\D/g, '').slice(0, 6))}
              placeholder="Enter 6-digit code"
              maxLength={6}
              autoFocus
            />
            {error && <div className="form-error">{error}</div>}
          </div>
        </div>
        <div className="modal-footer">
          <button
            className="btn btn-secondary"
            onClick={onClose}
            disabled={isLoading}
          >
            Cancel
          </button>
          <button
            className="btn btn-primary verify-btn"
            onClick={handleVerify}
            disabled={isLoading || code.length !== 6}
          >
            {isLoading ? (
              <span className="loading-text">
                <span className="spinner"></span>
                Verifying...
              </span>
            ) : (
              'Verify'
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default MFAVerificationModal;
